import { useQuery } from "react-query";
import { mailSettingsApi } from "frontend/src/api/mail-settings";
import { mailSettingsCacheKey } from "./shared";
export var useMailSettings = function () {
    return useQuery(mailSettingsCacheKey, mailSettingsApi.get);
};
